export default function PreviousDayoff({date, notes}){
    return (
        <div className="PreviousDayoff">
            <div><span className="date">[{date}]</span> {notes}</div>
        </div>
    );
}